import { GetDoctorSchcedule, PostDoctorSchcedule, GetDoctorScheduleSheet, CreateOrUpdateDeviceType, GetModalityTypes, GetProcedureCodes, CreateOrUpdateProcedureCode,
  CreateOrUpdateDevice, CreateOrUpdateBodyGroup, GetModuleList, CreateOrUpdateRole, GetRoles, GetUserList, CreateOrUpdateUser, GetHospitalInfo,
  CreateOrUpdateHospital } from '@/api/setting'

const setting = {
  state: {
    DoctorSchcedule: [],
    modalityTypes: [],
    ProcedureCodes: '',
    ModuleList: [],
    RoleList: [],
    UserList: [],
    hospitalInfo: {
      ability: '',
      address: '',
      aliasName: '',
      code: '',
      contacts: '',
      departList: [],
      hospitalId: '',
      name: '',
      phone: '',
      pyCode: ''
    }
  },
  mutations: {
    SET_DOCTORSCHCEDULE: (state, datas) => {
      state.DoctorSchcedule = datas
    },
    SET_MODALITY: (state, datas) => {
      state.modalityTypes = datas
    },
    SET_PROCEDURECODE: (state, datas) => {
      state.ProcedureCodes = datas
    },
    SET_MODULELIST: (state, datas) => {
      state.ModuleList = datas
    },
    SET_ROLELIST: (state, datas) => {
      state.RoleList = datas
    },
    SET_USERLIST: (state, datas) => {
      state.UserList = datas
    },
    SET_HOSPITALINFO: (state, datas) => {
      state.hospitalInfo = datas
    }
  },
  actions: {
    getDoctorSchcedule({ commit }) { // 执行单列表
      return new Promise((resolve, reject) => {
        GetDoctorSchcedule().then(response => {
          const data = response.data
          if (data.doctorList.length > 0) {
            commit('SET_DOCTORSCHCEDULE', data.doctorList)
          } else {
            commit('SET_DOCTORSCHCEDULE', [])
          }
          resolve()
        }).catch(error => {
          commit('SET_DOCTORSCHCEDULE', [])
          reject(error)
        })
      })
    },
    postDoctorSchcedule({ commit }, datas) { // 执行单列表
      return new Promise((resolve, reject) => {
        PostDoctorSchcedule(datas).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    getDoctorScheduleSheet({ commit }) { // 执行单列表
      return new Promise((resolve, reject) => {
        GetDoctorScheduleSheet().then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    CreateOrUpdateDeviceType({ commit }, datas) { // 执行单列表
      return new Promise((resolve, reject) => {
        CreateOrUpdateDeviceType(datas).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    getModalityTypes({ commit }) { // 执行单列表
      return new Promise((resolve, reject) => {
        GetModalityTypes().then(response => {
          const data = response.data
          if (data.modalityTypes.length > 0) {
            commit('SET_MODALITY', data.modalityTypes)
          } else {
            commit('SET_MODALITY', [])
          }
          resolve()
        }).catch(error => {
          commit('SET_MODALITY', [])
          reject(error)
        })
      })
    },
    GetProcedureCodes({ commit }, datas) { // 执行单列表
      return new Promise((resolve, reject) => {
        GetProcedureCodes(datas).then(response => {
          const data = response.data
          if (data.totalCount > 0) {
            commit('SET_PROCEDURECODE', data)
          } else {
            commit('SET_PROCEDURECODE', '')
          }
          resolve()
        }).catch(error => {
          commit('SET_PROCEDURECODE', '')
          reject(error)
        })
      })
    },
    CreateOrUpdateProcedureCode({ commit }, datas) { // 执行单列表
      return new Promise((resolve, reject) => {
        CreateOrUpdateProcedureCode(datas).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    CreateOrUpdateDevice({ commit }, datas) { // 执行单列表
      return new Promise((resolve, reject) => {
        CreateOrUpdateDevice(datas).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    CreateOrUpdateBodyGroup({ commit }, datas) { // 执行单列表
      return new Promise((resolve, reject) => {
        CreateOrUpdateBodyGroup(datas).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetModuleList({ commit }) { // 执行单列表
      return new Promise((resolve, reject) => {
        GetModuleList().then(response => {
          const data = response.data
          if (data.modules.length > 0) {
            commit('SET_MODULELIST', data.modules)
          } else {
            commit('SET_MODULELIST', [])
          }
          resolve()
        }).catch(error => {
          commit('SET_MODULELIST', [])
          reject(error)
        })
      })
    },
    CreateOrUpdateRole({ commit }, datas) { // 执行单列表
      return new Promise((resolve, reject) => {
        CreateOrUpdateRole(datas).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetRoles({ commit }) { // 执行单列表
      return new Promise((resolve, reject) => {
        GetRoles().then(response => {
          const data = response.data
          if (data.length > 0) {
            commit('SET_ROLELIST', data)
          } else {
            commit('SET_ROLELIST', [])
          }
          resolve()
        }).catch(error => {
          commit('SET_ROLELIST', [])
          reject(error)
        })
      })
    },
    GetUserList({ commit }, datas) { // 执行单列表
      return new Promise((resolve, reject) => {
        GetUserList(datas).then(response => {
          const data = response.data
          if (data.userList.length > 0) {
            commit('SET_USERLIST', data.userList)
          } else {
            commit('SET_USERLIST', [])
          }
          resolve()
        }).catch(error => {
          commit('SET_USERLIST', [])
          reject(error)
        })
      })
    },
    CreateOrUpdateUser({ commit }, datas) { // 执行单列表
      return new Promise((resolve, reject) => {
        CreateOrUpdateUser(datas).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetHospitalInfo({ commit }, datas) { // 执行单列表
      return new Promise((resolve, reject) => {
        GetHospitalInfo(datas).then(response => {
          const data = response.data
          commit('SET_HOSPITALINFO', data)
          resolve()
        }).catch(error => {
          commit('SET_HOSPITALINFO', '')
          reject(error)
        })
      })
    },
    CreateOrUpdateHospital({ commit }, datas) { // 执行单列表
      return new Promise((resolve, reject) => {
        CreateOrUpdateHospital(datas).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default setting
